import { useState, useEffect } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { t } from "i18next";

const useLinkedInPost = () => {
  const [linkedInWindow, setLinkedInWindow] = useState(null);
  const apiUrl = process.env.REACT_APP_API_URL;
  const apiUrlFront = process.env.REACT_APP_API_FRONT_URL;

  const handleLinkedInAuth = (formData) => {
    const redirectUri = encodeURIComponent(
      `${window.location.origin}/talent/post/PostDetails/`
    );

    const linkedInAuthUrl = `https://www.linkedin.com/oauth/v2/authorization?response_type=code&client_id=${process.env.REACT_APP_LINKEDIN_CLIENT_ID}&redirect_uri=${redirectUri}&scope=openid%20email%20profile%20w_member_social`;

    const newWindow = window.open(linkedInAuthUrl, "_blank");
    setLinkedInWindow(newWindow);

    // Store form data temporarily
    localStorage.setItem("postFormData", JSON.stringify(formData));

    // Listen for auth response
    window.addEventListener("message", handleAuthMessage);
  };

  const handleAuthMessage = async (event) => {
    if (event.origin !== window.location.origin) return;

    const { code } = event.data;
    if (code) {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}authentication/linkedin_callback_post/`,
          { params: { code } }
        );

        const { linkedIn_access_token, linkedin_person_id } = response.data;
        createLinkedInPost(linkedIn_access_token, linkedin_person_id);
      } catch (error) {
        console.error("LinkedIn auth failed:", error);
      } finally {
        cleanup();
      }
    }
  };

  const createLinkedInPost = async (token, personnalId) => {
    try {
      const formData = JSON.parse(localStorage.getItem("postFormData"));
      if (!formData) {
        console.error("Form data not found in localStorage!");
        return;
      }
      console.log("FormData: ", formData);
      const {
        postImage,
        postTitle,
        postDescription,
        postRequirement,
        postDeadline,
        location,
        numPeople,
        workingMode,
        salary,
        currency,
        offerType,
        postId,
        recruiterEmail
      } = formData;
      // console.log("postTitle:", postTitle);
      // console.log("postDeadline:", postDeadline);
      // console.log("location:", location);
      // console.log("postDescription:", postDescription);
      // console.log("postRequirement:", postRequirement);
      // console.log("postId:", postId);
      if (
        !postTitle ||
        !postDeadline ||
        // !location ||
        !postDescription ||
        !postRequirement ||
        !postId
      ) {
        toast.error(t("postPage.errors.missingFields"));
        return;
      }

      await axios.post(
        `${apiUrl}authentication/linkedin/post-create/`,
        {
          token: token,
          personnalId: personnalId,
          subject: postTitle,
          lien: `${apiUrlFront}viewjob/${postId}`,
          postDeadline: postDeadline,
          location: location,
          postImage: postImage,
          postDescription: postDescription,
          requirement: postRequirement,
          workMode: workingMode,
          salary: salary || null,
          numToHire: numPeople || null,
          currency: currency,
          recruiter_email: recruiterEmail
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          },
        }
      );

      // Success handling
      localStorage.removeItem("postFormData");
      if (window.opener) {
        window.opener.postMessage(
          { action: "postCreated" },
          window.location.origin
        );
        window.close();
      }
    } catch (error) {
      console.error("LinkedIn post creation failed:", error);
    }
  };

  const cleanup = () => {
    window.removeEventListener("message", handleAuthMessage);
    linkedInWindow?.close();
  };

  useEffect(() => {
    return cleanup;
  }, []);

  return { handleLinkedInAuth };
};

export default useLinkedInPost;
